import axios from 'axios';

// API请求基础URL
const API_URL = '/auth';

class AuthService {
  // 登录方法
  login(username, password) {
    return axios
      .post(`${API_URL}/login`, {
        username,
        password
      })
      .then(response => {
        if (response.data.token) {
          // 存储token到本地存储
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  // 登出方法
  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    // 也可以调用后端的登出API
    return axios.post(`${API_URL}/logout`).catch(() => {
      // 即使后端登出失败，也要确保前端已登出
      console.log('前端已登出');
    });
  }

  // 获取当前登录用户
  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

export default new AuthService();
